import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RootScopeService } from 'src/app/services/root-scope.service';
export interface IMySelectOption {
  id: number;
  value: string;
  label: string;
}
declare var $: any;

@Component({
  selector: 'app-additional-account-modal',
  templateUrl: './additional-account-modal.component.html',
  styleUrls: ['./additional-account-modal.component.scss'],
})
export class AdditionalAccountModalComponent implements OnInit {
  @Input() data: string = 'additional';
  @Input() activeChatCustomers: any = [];
  public selectedChatCust:  any = {};
  disable: boolean = true;
  hideSubHeading: boolean = false;
  @Output() buttonClicked = new EventEmitter<any>();
  public selectedValue?: IMySelectOption;
  public secondSelectedValue?: IMySelectOption;
  public options: IMySelectOption[] = [
    {
      id: 1,
      value: 'value1',
      label: 'Authorized user required info',
    },
    {
      id: 2,
      value: 'value2',
      label: 'Agent required info',
    },
  ];

  public suboptions: IMySelectOption[] = [
    {
      id: 3,
      value: 'HR-Manager',
      label: 'HR/ Manager',
    },
    {
      id: 4,
      value: 'Clientpartner',
      label: 'Client Partner',
    },
    {
      id: 5,
      value: 'Unionrep',
      label: 'Union Rep',
    },
  ];
  selectedRole: any;
  constructor( public rootService: RootScopeService) { }

  ngOnInit(): void {
    this.selectedValue = this.options[0]
    this.hideSubHeading = true;
    this.disable = true;
  }

  /*click event response send back to parent compnent  */
  typeHeadChange(event) {
    this.disable = true;
    this.buttonClicked.emit({
      btnName: event.target.text,
      primaryValue: this.selectedValue,
      secondaryValue: this.secondSelectedValue,
      customer: this.selectedChatCust
    });
  }

  /*selection of radio button enable/disable the continue button function  */
  toggleMethod() {
    if (this.selectedValue?.id === 1) {
      this.hideSubHeading = true;
      this.disable = true;
    } else {
      this.hideSubHeading = false;
      this.disable = false;
      this.secondSelectedValue = {
        id: NaN,
        value: '',
        label: '',
      };
    }
  }
  /* sub radio button selection base set enable and disable continue button */
  subtoggleMethod() {
    if (this.secondSelectedValue?.id) {
      
      

      /**Enabling continue button only if parent CA has roleType HRPRO/Manager /Union Repo  
       * CCR1-9612*/
       
       if(this.rootService.isLiveChat){

        if(this.activeChatCustomers?.length > 1 ){ /** case of multiple chats */
          if(this.rootService?.authorized_roletype?.includes(this.selectedChatCust?.defaultRole)){
            this.disable = false;
            return;
          }
          else{
            this.disable = true;
            return;
          }
        }
        else{
          this.rootService.authorizedRoleType = this.rootService.customerTabs.some(x => (x.clientId == this.rootService.activeCustTab.clientId) &&  
                                                          (!x?.activeCall || x?.activeChat) && !x?.additionalAccount &&
                                                          this.rootService?.authorized_roletype?.includes(x?.defaultRole))
        }

        
      }
      else {
        this.rootService.authorizedRoleType = this.rootService.customerTabs.some(x =>
        (x?.activeCall || x?.activeChat) &&
        !x?.additionalAccount &&
        this.rootService?.authorized_roletype?.includes(x?.defaultRole)
      );
    }

    if(this.rootService.authorizedRoleType)
      this.disable = false;
    else
      this.disable = true;
    }
  }
  /*multi customer Selection value update in global valribale  */
  changeCustomer() {
    if (this.selectedChatCust) { 
      this.disable = false; 
    }
  }

  disableOpt(valuePassed: any): boolean {
    let optEnable = true;
    if (this.rootService.authorized_roletype?.includes(valuePassed.defaultRole)) {
      optEnable = false;
    } else {
      optEnable = true;
    }
    return optEnable;
  }
}
